import { BaseClient } from '@/api'
import request from '@/utils/request'

export class StationClient extends BaseClient {
  constructor(
  ) {
    super('stations')
  }

  async createWithUser(data: any, username:string): Promise<any> {
    return request({
      url: `/${this.path}/${username}`,
      method: 'post',
      data
    })
  }
}
